import React, { useContext } from 'react';
import classes from '@/components/Collections/Collection/Collection.module.scss';
import { Card } from 'react-bootstrap';
import { Button } from '@/components';
import t from '@/utils/Language/Collection-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { viewportContext } from '@/context/viewport.context';

const CategoryEmptyState = () => {
  const router = useRouter();
  const { isMobile } = useContext(viewportContext);

  const getEmptyStateDesc = () => {
    const content = t(
      'Categories are a way to organize collections. You can save a resource to a category by clicking the iconName icon in your search results.'
    );
    const replacedContent = content.replace('${iconName}', '__ICON__');
    const htmlContent = replacedContent.split('__ICON__');

    return (
      <p>
        {htmlContent[0]}
        <FontAwesomeIcon icon={['fas', 'book']} />
        {htmlContent[1]}
      </p>
    );
  };

  return (
    <div className={[classes?.collectionEmptyState, classes?.categoryEmptyState].join(' ')}>
      <Card>
        <div className={classes.collectionEmptyStateBody}>
          <h5 className={classes.collectionEmptyStateTitle}>{t('You don’t have anything in this category yet')}</h5>
          <div className={classes.collectionEmptyStateContent}>{getEmptyStateDesc()}</div>
          <div className={classes.collectionEmptyStateButtons}>
            <Button
              dataCy="button-add-client"
              type="primary"
              icon={{ style: 'fas', font: 'search' }}
              text={t('Search for resources')}
              styles={{ width: isMobile ? 'full' : 'half' }}
              onButtonClick={() => router.push('/browse')}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CategoryEmptyState;
